<template>
  <b-modal id="ReviewTeacher" hide-footer centered title="Selecionar Professor revisor">
    <b-overlay :show="loading">

        <b-form-group
            label="Professor">

            <!-- Input -->
            <multiselect
                v-model="teacher"
                :options="teachers"
                track-by="id"
                label="name"
                placeholder=""
                @select="(value) => {
                    form.teacher_id = value.id;
                }"
                @remove="() => form.teacher_id = null"
                selectLabel="Selecionar"
                deselectLabel="Desmarcar"
                selectedLabel="Selecionado">

                    <span slot="noResult">
                        Ops! Nenhum resultado encontrado na pesquisa :(
                    </span>

                    <span slot="noOptions">
                        Não há corretores disponíveis para exibir :(
                    </span>

            </multiselect>

        </b-form-group>
        <b-form-group>

            <b-button type="button" class="mt-3" variant="primary" @click="handleUpdate" :disabled="loading">
                Salvar Alteração
            </b-button>

        </b-form-group>
    </b-overlay>
  </b-modal>
</template>

<script>
export default {
    props: ['teachers'],
    data() {
        return {

            loading: false,
            teacher: null,
            form: {
                teacher_id: null
            },
            essay: null,
        }
    },
    watch:{
        type (value){
            this.mode = null
            this.theme = null
        }
    },  
    created() {
        this.$root.$on('ReviewTeacher', (essay) => {
            this.essay = essay
            this.$bvModal.show('ReviewTeacher')
        })
    },
    methods: {
        handleUpdate(){
            this.loading = true
            axios.post('/teacher/reviews/store', {
                essay_id: this.essay.id,
                teacher_id: this.form.teacher_id,
            }).then((result) => {
                this.$toast.success(result.data.data.message)
                this.$emit('created')
                this.$bvModal.hide('ReviewTeacher')
                
            }).catch((err) => {
                this.$toast.error('Erro ao criar revisão!');
            }).finally(()=> this.loading = false);
        }
    }
}
</script>

<style>

</style>